import { FieldVisibility } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/components/MasterDocumentForm/useFieldVisibility';
import { DocumentWorkflowTemplateType, SignatureType } from '@dealstack/shared/lib/generated';

export const getSignatureTypeVisibility = (type: DocumentWorkflowTemplateType): FieldVisibility => {
	if (type === DocumentWorkflowTemplateType.SIGNATURE_REQUIRED) {
		return { show: true };
	}
	if (type === DocumentWorkflowTemplateType.SIGNABLE_FORM) {
		return { show: true, locked: true, lockedValue: SignatureType.ELECTRONIC };
	}
	return { show: false };
};
